module.exports = __webpack_public_path__ + "img/game.5a47dedd.png";